import { Typography, Box, useTheme } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../models/enums";
import ArrowHoverIcon from "../icons/DynamicLinkArrow";
import MainPaperWrapper from "../item/MainPaperWrapper";

type NavigationRedirectBoxProps = {
  title: string;
  route: RouteEnum;
};

const NavigationRedirectBox: React.FC<NavigationRedirectBoxProps> = ({
  title,
  route,
}: NavigationRedirectBoxProps) => {
  const [hovered, setHovered] = useState(false);

  const theme = useTheme();
  const navigate = useNavigate();

  const onClick = (): void => {
    navigate(route);
  };

  const onMouseEnter = (): void => {
    setHovered(true);
  };

  const onMouseLeave = (): void => {
    setHovered(false);
  };

  return (
    <Box
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <MainPaperWrapper
        sx={{
          display: "flex",
          padding: "1.5em",
          cursor: "pointer",
          maxWidth: "530px",
          justifyContent: "space-between",

          "&:hover": {
            border: `1px solid ${theme.palette.primary.main}`,
          },
        }}
      >
        <Typography variant="body1Bold">{title}</Typography>
        <Box>
          <ArrowHoverIcon hovered={hovered} setHovered={setHovered} />
        </Box>
      </MainPaperWrapper>
    </Box>
  );
};

export default NavigationRedirectBox;
